import image1 from "../assets/img/service/services-1.jpg";
import image2 from "../assets/img/service/services-2.jpg";
import image3 from "../assets/img/service/services-3.jpg";
import image4 from "../assets/img/service/services-4.jpg";
import image5 from "../assets/img/service/services-5.jpg";
import image6 from "../assets/img/service/services-6.jpg";
import image7 from "../assets/img/service/services-1.jpg";
import image8 from "../assets/img/service/services-2.jpg";

const servicesData = [
    {
        id: 'road-making',
        icon: <i className="flaticon-project"></i>,
        title: 'Road Making',
        description: 'We deliver highly durable and expertly graded road construction services for seamless, safe, and efficient public transportation.',
        number: '1',
        image: image1,
    },
    {
        id: 'drainage-line-work',
        icon: <i className="flaticon-data"></i>,
        title: 'Drainage Line Work',
        description: 'Our robust drainage line solutions ensure effective water management, preventing flooding and protecting urban and rural infrastructure.',
        number: '2',
        image: image2,
    },
    {
        id: 'irrigation-line-work',
        icon: <i className="flaticon-design-thinking"></i>,
        title: 'Irrigation Line Work',
        description: 'We construct reliable and efficient irrigation systems designed to optimize water distribution for agricultural and land development projects.',
        number: '3',
        image: image3,
    },
    {
        id: 'pipeline-work',
        icon: <i className="flaticon-wrench-1"></i>,
        title: 'Pipeline Work',
        description: 'Expert pipeline installation services guaranteeing safe, leak-proof, and long-lasting underground utility and sanitation networks.',
        number: '4',
        image: image4,
    },
    {
        id: 'rcc-road',
        icon: <i className="flaticon-it-department"></i>,
        title: 'RCC Road',
        description: 'High-strength Reinforced Cement Concrete (RCC) road construction designed to withstand heavy commercial traffic and offer supreme longevity.',
        number: '5',
        image: image5,
    },
    {
        id: 'damar-road',
        icon: <i className="flaticon-project"></i>,
        title: 'Damar Road',
        description: 'High-quality asphalt (Damar) road paving that provides exceptionally smooth surfaces and withstands extreme weather conditions over time.',
        number: '6',
        image: image6,
    },
    {
        id: 'beautification-work',
        icon: <i className="flaticon-idea-1"></i>,
        title: 'Beautification Work',
        description: 'Enhancing public and private spaces with modern civic beautification, landscaping, and structural improvements for local communities.',
        number: '7',
        image: image7,
    },
    {
        id: 'renovation-work',
        icon: <i className="flaticon-wrench-1"></i>,
        title: 'Renovation Work',
        description: 'Comprehensive structural renovation to safely upgrade, repair, and revitalize existing civil infrastructure to meet modern standards.',
        number: '8',
        image: image8,
    }
];

export default servicesData;